import { AVATAR_PICKER_DEFAULT_LIST } from './AvatarPickerDefaultConstants';
import { AVATAR_PICKER_DEFAULT_STUDENT_LIST } from './AvatarPickerDefaultStudentConstants';
import { AVATAR_PICKER_KYA_LIST } from './AvatarPickerKYAConstants';

export const AVATAR_PICKER_LISTS = {
  AVATAR_PICKER_DEFAULT_LIST,
  AVATAR_PICKER_DEFAULT_STUDENT_LIST,
  AVATAR_PICKER_KYA_LIST
};
